// Validate Net Weight Percentage on Single Ornament

export const validateCurrentRow = (
  groupDetails,
  currentIndex,
  enabledLeadValidateForNewLoan,
  minNetWeightValue,
  checkValidationForNewPacket,
  toastUpdate
) => {
  const currentRow = groupDetails?.[currentIndex];
  if (!currentRow) return true;
  const grossWeight = Number(currentRow?.grossWeight);
  const netWeight = Number(currentRow?.netWeight);

  if (enabledLeadValidateForNewLoan) {
    const maxNetWeight = Number(minNetWeightValue);
    const minNetWeightPercentage = (grossWeight * maxNetWeight) / 100;
    if (netWeight < minNetWeightPercentage) {
      if (
        groupDetails?.[currentIndex]?.isOrnamentAudited ||
        checkValidationForNewPacket(currentIndex)
      ) {
        toastUpdate(
          "Error",
          `Net weight cannot be less than ${minNetWeightPercentage}. Please do part release firstly`,
          true
        );
      } else {
        toastUpdate(
          "Error",
          `Net weight cannot be less than ${minNetWeightPercentage}.`,
          true
        );
      }
      return false;
    }
  }
  return true;
};

// Validate Net Weight Percentage on Full Array Ornaments

export const validateNetWeightPercentage = (
  groupDetails = [],
  minNetWeightValue
) => {
  if (!Array.isArray(groupDetails) || groupDetails.length === 0) {
    return { valid: true, particulars: "" };
  }
  for (let index = 0; index < groupDetails.length; index++) {
    const item = groupDetails[index];
    const grossWeight = Number(item?.grossWeight);
    const netWeight = Number(item?.netWeight);
    if (isNaN(grossWeight) || isNaN(netWeight)) continue;
    const maxAllowedNetWeight = (grossWeight * minNetWeightValue) / 100;
    if (netWeight < maxAllowedNetWeight) {
      return {
        valid: false,
        particulars: item?.particulars || "",
      };
    }
  }
  return { valid: true, particulars: "" };
};

// update packet details and source of ownership

export const normalizePacketAndOwnership = (groupDetails = []) => {
  if (!Array.isArray(groupDetails) || groupDetails.length === 0)
    return groupDetails;

  const firstPacket = groupDetails[0];

  // Find first valid (non-empty) sourceOfOwnership
  const validSourceOfOwnership = groupDetails.find((item) =>
    item?.sourceOfOwnership?.trim()
  )?.sourceOfOwnership;

  return groupDetails.map((item) => ({
    ...item,
    packetNumber: firstPacket?.packetNumber,
    packetSize: firstPacket?.packetSize,
    packetWeight: firstPacket?.packetWeight,
    packetSealed: firstPacket?.packetSealed,
    packetSealNumber: firstPacket?.packetSealNumber,
    sourceOfOwnership: item?.sourceOfOwnership?.trim()
      ? item.sourceOfOwnership
      : validSourceOfOwnership ?? item.sourceOfOwnership,
  }));
};
